// Mock data for Cane Corso website

export const mockBreeders = [
  {
    id: 1,
    name: "Bülent ÖZDEM",
    fciName: "Corso Azor's Love Nest",
    registrationNo: "0967 / FCI 120 / 2019",
    city: "Ankara",
    phone: "0534 222 7878",
    email: "ozdemelk@hotmail.com",
    website: "",
    instagram: "",
    facebook: ""
  },
  {
    id: 2,
    name: "Ediz YÜCETİN",
    fciName: "Deities Corso Kennel",
    registrationNo: "",
    city: "İstanbul",
    phone: "0532 235 3158",
    email: "edizyucetin@hotmail.com",
    website: "www.deitiescorso.com",
    instagram: "@deities_kennel_turkey",
    facebook: ""
  },
  {
    id: 3,
    name: "Emrah ÜRGER",
    fciName: "Vento Del Mediterraneo",
    registrationNo: "0404 / FCI 96 / 2015",
    city: "Adana",
    phone: "0544 842 5525",
    email: "emrrah1@gmail.com",
    website: "",
    instagram: "@emrah_urger",
    facebook: ""
  },
  {
    id: 4,
    name: "Fatih BOSUM",
    fciName: "Ruler Of The Island",
    registrationNo: "FCI 137 / 2021",
    city: "Bornova/İzmir",
    phone: "0533 232 1981",
    email: "fbosum@hotmail.com",
    website: "",
    instagram: "",
    facebook: ""
  },
  {
    id: 5,
    name: "Gökhan & Gonca VAROL",
    fciName: "Parte Del Leone",
    registrationNo: "0759 / FCI 54 / 2018",
    city: "Soma / Manisa",
    phone: "0541 797 0198",
    email: "",
    website: "",
    instagram: "@canecorsoturkey_partedelleone",
    facebook: ""
  },
  {
    id: 6,
    name: "Mertcan BAHAR",
    fciName: "Del Sole Primavera",
    registrationNo: "1451 / FCI 91 / 2023",
    city: "Edirne",
    phone: "0535 515 1911",
    email: "delsoleprimavera@gmail.com",
    website: "www.delsoleprimavera.com",
    instagram: "@del_sole_primavera",
    facebook: ""
  },
  {
    id: 7,
    name: "Nihat KOLCU",
    fciName: "Naska Cane Corso",
    registrationNo: "1156 / FCI 76 / 2021",
    city: "Ankara",
    phone: "0543 544 0600",
    email: "nihatkolcu@kam.com.tr",
    website: "www.naskacanecorso.com",
    instagram: "",
    facebook: ""
  },
  {
    id: 8,
    name: "Zehra BAYRAM ALTINTAŞ",
    fciName: "King Of The Corso's",
    registrationNo: "0950 / FCI 103 / 2019",
    city: "Buca/İzmir",
    phone: "0545 235 8535",
    email: "kingofthecorso@gmail.com",
    website: "",
    instagram: "",
    facebook: "https://www.facebook.com/share/18VPQCGnVR/?mibextid=wwXlfr"
  }
];

export const mockEvents = [
  {
    id: 1,
    titleTr: "2024 Ulusal Cane Corso Şampiyonası",
    titleEn: "2024 National Cane Corso Championship",
    titleRu: "Чемпионат Кане Корсо 2024",
    date: "2024-05-15",
    location: "İstanbul",
    coverImage: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1568572933382-74d440642117?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=800&h=600&fit=crop"
    ]
  },
  {
    id: 2,
    titleTr: "Üretici Eğitim Semineri",
    titleEn: "Breeder Training Seminar",
    titleRu: "Семинар по обучению заводчиков",
    date: "2024-03-20",
    location: "İzmir",
    coverImage: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1568572933382-74d440642117?w=800&h=600&fit=crop"
    ]
  },
  {
    id: 3,
    titleTr: "Cane Corso Sosyalleşme Günü",
    titleEn: "Cane Corso Socialization Day",
    titleRu: "День социализации Кане Корсо",
    date: "2024-06-10",
    location: "Ankara",
    coverImage: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1568572933382-74d440642117?w=800&h=600&fit=crop"
    ]
  }
];

export const mockArticles = [
  {
    id: 1,
    titleTr: "Cane Corso Beslenme Rehberi",
    titleEn: "Cane Corso Nutrition Guide",
    titleRu: "Руководство по питанию Кане Корсо",
    category: "nutrition",
    date: "2024-01-15",
    author: "Dr. Ahmet Yılmaz",
    excerpt: "Cane Corso beslenmesinde dikkat edilmesi gereken temel noktalar...",
    image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&h=400&fit=crop"
  },
  {
    id: 2,
    titleTr: "Cane Corso Eğitim Teknikleri",
    titleEn: "Cane Corso Training Techniques",
    titleRu: "Методы обучения Кане Корсо",
    category: "training",
    date: "2024-02-20",
    author: "Mehmet Demir",
    excerpt: "Cane Corso eğitiminde başarılı olmak için ipuçları...",
    image: "https://images.unsplash.com/photo-1568572933382-74d440642117?w=600&h=400&fit=crop"
  },
  {
    id: 3,
    titleTr: "Kalça Displazisi ve Önleme Yöntemleri",
    titleEn: "Hip Dysplasia and Prevention Methods",
    titleRu: "Дисплазия тазобедренного сустава и методы профилактики",
    category: "health",
    date: "2024-03-10",
    author: "Dr. Ayşe Kaya",
    excerpt: "Cane Corso'larda kalça displazisi riski ve önleme yöntemleri...",
    image: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=600&h=400&fit=crop"
  }
];

export const mockAnnouncements = [
  {
    id: 1,
    titleTr: "2024 Üyelik Kayıtları Başladı",
    titleEn: "2024 Membership Registration Started",
    titleRu: "Регистрация членов на 2024 год началась",
    date: "2024-01-05",
    content: "2024 yılı üyelik kayıtları 1 Ocak 2024 tarihinde başlamıştır..."
  },
  {
    id: 2,
    titleTr: "Yeni Web Sitemiz Yayında",
    titleEn: "Our New Website is Live",
    titleRu: "Наш новый сайт запущен",
    date: "2024-02-01",
    content: "Yeni web sitemiz üzerinden tüm işlemlerinizi gerçekleştirebilirsiniz..."
  },
  {
    id: 3,
    titleTr: "FCI Sertifika Programı",
    titleEn: "FCI Certificate Program",
    titleRu: "Программа сертификации FCI",
    date: "2024-02-15",
    content: "FCI sertifika programı hakkında detaylı bilgi..."
  }
];

export const mockDogs = [
  {
    id: 1,
    name: "CAESAR DELLA CASA",
    gender: "male",
    skbNo: "TR-123456",
    color: "Black",
    birthDate: "2020-05-10",
    titles: "CH TR, INT CH",
    owner: "Ahmet Yılmaz",
    phone: "(555) 123 45 67",
    availableForMating: true
  },
  {
    id: 2,
    name: "BELLA FORTEZZA",
    gender: "female",
    skbNo: "TR-234567",
    color: "Blue",
    birthDate: "2021-03-15",
    titles: "CH TR",
    owner: "Ayşe Kaya",
    phone: "(555) 345 67 89",
    availableForMating: false
  },
  {
    id: 3,
    name: "GUARDIANO NERO",
    gender: "male",
    skbNo: "TR-345678",
    color: "Black Brindle",
    birthDate: "2019-08-20",
    titles: "INT CH, GRAND CH TR",
    owner: "Mehmet Demir",
    phone: "(555) 234 56 78",
    availableForMating: true
  }
];

export const turkishProvinces = [
  "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Amasya", "Ankara", "Antalya",
  "Artvin", "Aydın", "Balıkesir", "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur",
  "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Edirne",
  "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane",
  "Hakkâri", "Hatay", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş", "Karabük",
  "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırklareli", "Kırşehir", "Kocaeli",
  "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş",
  "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
  "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli",
  "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"
];
